export type StockCheckable = {
    isUniquelyIdentified?: boolean
}

export function isStockEquipment(resource: StockCheckable): boolean {
    return resource.isUniquelyIdentified === false
}

export function isStockEquipmentType(isUniquelyIdentified: boolean): boolean {
    return !isUniquelyIdentified
}

export function bulkEquipmentCandidateId(rentalAssetTypeId: string): string {
    return `bulk:${rentalAssetTypeId}`
}

export function maxQuantityForBulkAssignGap(
    quantityNeeded: number,
    assignedCount: number,
    poolSize: number,
): number {
    const remaining = quantityNeeded - assignedCount
    return Math.max(0, Math.min(remaining, poolSize))
}

export function formatGroupedEquipmentName(resourceName: string, quantity: number): string {
    return quantity > 1 ? `${resourceName} × ${quantity}` : resourceName
}

export function comparePoolResourceNames(
    leftName: string | null,
    rightName: string | null,
): number {
    return (leftName ?? '').localeCompare(rightName ?? '')
}
